var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_container container"},[_c('butn',{staticClass:"allBtn",attrs:{"size":"mini","btntype":"primary","title":"全部数据"},on:{"click":_vm.allClick}}),_c('img',{staticClass:"img",attrs:{"src":require("../../assets/image/jiaxing/cs.jpeg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }